import {WorkLocationType} from "@app/shared/enums/work-location-type.enum";

export function getAddressType() {
  return Address;
}

export class Address {

  id: number;
  version?: number;

  addrName?: string;
  addrLn1: string;
  addrLn2: string;

  city: string;
  stateCode: string;
  postalCode: string;
  country: string;
}


export class AddressInfo {
  userId: number;
  locationCode: string;
  addrType: WorkLocationType;
  addressId: number;
  addrLn1: string;
  addrLn2: string;
  current?: boolean;
  city: string;
  stateCode: string;
  postalCode: string;
  projectName: string;
  addrName: string;
  country: string;
}
